<template>
    <j-modal :title="title" :width="width" :visible="visible" switchFullscreen @ok="handleOk" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }" @cancel="handleCancel" cancelText="关闭">
        <iot-model-points-group-menber-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit" @addMenber></iot-model-points-group-menber-form>
    </j-modal>
</template>

<script>
    import IotModelPointsGroupMenberForm from './IotModelPointsGroupMenberForm'
    export default {
        name: 'IotModelPointsGroupMenberModal',
        components: {
            IotModelPointsGroupMenberForm
        },
        data() {
            return {
                title: '',
                width: 800,
                visible: false,
                disableSubmit: false
            }
        },
        methods: {
            add(data) {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.realForm.add(data);
                })
            },
            edit(record) {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.realForm.edit(record);
                })
            },
            close() {
                this.$emit('close');
                this.visible = false;
            },
            handleOk() {
                this.$refs.realForm.submitForm();
            },
            submitCallback(data) {
                this.$emit('ok', data);
                this.visible = false;
            },
            handleCancel() {
                this.close()
            }
        }
    }
</script>